'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Animate = require('./Animate');

var _Animate2 = _interopRequireDefault(_Animate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Animate2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bee-animate/build/index.js
// module id = 57
// module chunks = 0